module.exports = __webpack_public_path__ + "img/29-800x800.4ba2786b.jpg";